import ReactDOM from 'react-dom';

export default ({ children, name, forceLast = false }) => {
  let nameRandom = (((1 + Math.random()) * 0x10000) | 0)
    .toString(16)
    .substring(1);
  let modalRoot = document.getElementById(`root-${name}`);
  if (!modalRoot) {
    const tempEl = document.createElement('div');
    tempEl.id = `root-${name ? name : nameRandom}`;

// 🔽 Isso não funcionou...impossibilitava editar estabelecimento e produto nos modais correspodentes...
    //if (forceLast) {
    //  document.body.appendChild(tempEl);
    //} else {
    //  document.body.append(tempEl); // ou append, dependendo do fluxo normal
    //}

    
    document.body.append(tempEl); 
    
    

    modalRoot = tempEl;
  }
  return ReactDOM.createPortal(children, modalRoot);
};
